module.exports = __webpack_public_path__ + "static/media/ORGDASH-ManageWidget.ea1a513c.png";